export default __webpack_public_path__ + "static/media/pj-chatbotfit.8cca94a6.png";